import { createFileRoute } from "@tanstack/react-router"
import { procedureTypesViewLayoutHandle } from "src/views/ProcedureTypesView/constants"
import { ProcedureTypesView } from "src/views/ProcedureTypesView/ProcedureTypesView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/procedure-types/")(
	{
		component: ProcedureTypesView,
		staticData: procedureTypesViewLayoutHandle,
	},
)
